import createApiClient from './apiClient';
import { cachedRequest, invalidateStudentCache } from '../utils/apiDataCache';

const studentApi = createApiClient(process.env.REACT_APP_ATHENIAN_STUDENT_SERVICE_URL);

export const getIepChecklist = (studentId) =>
  cachedRequest(`student:${studentId}:iep-checklist`, () =>
    studentApi.get(`/${studentId}/iep-checklist`, {
      validateStatus: (status) => status === 200 || status === 404,
    }));

export const updateIepChecklistSection = (studentId, sectionName, data) => {
  invalidateStudentCache(studentId);
  return studentApi.put(`/${studentId}/iep-checklist/sections/${sectionName}`, { data });
};

export const exportIepChecklistPdf = (studentId) =>
  studentApi.get(`/${studentId}/iep-checklist/export-pdf`, { responseType: 'blob' });

export const deleteIepChecklist = (studentId) => {
  invalidateStudentCache(studentId);
  return studentApi.delete(`/${studentId}/iep-checklist`);
};

export const evaluateIepFromDocs = (studentId) => {
  invalidateStudentCache(studentId);
  return studentApi.post(`/${studentId}/iep-checklist/evaluate-from-docs`);
};
